import React, { useEffect, useState } from 'react';
import {
    Button,
    Dialog,
    DialogBackdrop,
    DialogPanel,
    DialogTitle
} from '@headlessui/react';
import TextField from '../components/TextField';
import { Row } from "../components/Flex";
import { PrimaryButton, SecondaryButton } from "../components/buttons/Buttons";
import { Tag } from "../typings";

interface Props {
    max: number;
    open: boolean;
    onClose: () => void;
    onAdd: (email: string) => void;
}

function AddUserDialog({ max, open, onAdd, onClose }: Props) {
    const [email, setEmail] = useState('');

    const onConfirm = () => onAdd(email);

    return (
        <Dialog open={open} as="div" onClose={onClose} className="dialog-container">
            <DialogBackdrop className="dialog-backdrop"/>
            <div className="dialog">
                <DialogPanel className="dialog-box">
                    <DialogTitle as="div" className="dialog-title">
                        Add existing user, {max} more empty slots
                    </DialogTitle>
                    <TextField label="Name" value={email} setValue={setEmail} />
                    <Row gap={8} style={{ justifyContent: 'flex-end', marginTop: '8px' }}>
                        <PrimaryButton label="Add" onClick={onConfirm} disabled={!email || max <= 0} />
                        <SecondaryButton label="Cancel" onClick={onClose} />
                    </Row>
                </DialogPanel>
            </div>
        </Dialog>
    );
}

export default AddUserDialog;
